// @flow
import {connect} from 'react-redux';
import {compose, withProps} from 'react-recompose';

import I18n from '../../../lib/i18n';
import {fetchAgreementsByProductOfferings} from '../../../modules/Agreements/actions';
import {hasAlreadyValidatedNeededAgreementsSelector} from '../../../modules/Agreements/selectors';
import {
  activationBonusAmountSelector,
  isDiscountSelector,
} from '../../../modules/Bonuses';
import {
  customPaymentMeanSelector,
  hasCustomPaymentMeanSelector,
} from '../../../modules/Customer/selectors';
import {getSelectedLinePhoneNumber} from '../../../modules/Dashboard/reducer';
import {isLoadingSelector} from '../../../modules/LoadingStatus/reducer';
import {newOfferPriceSelector} from '../../../modules/NewOffer/selectors';
import {addPaymentMeanDuringActivate} from '../../../modules/Payment/actions';
import {phoneNumbersSelector} from '../../../modules/SignUp/AvailablePhoneNumbers';
import {verifyBonuses} from '../../../modules/SignUp/Bonus/actions';
import {
  chosenPhoneNumberSelector,
  portabilityCharacteristicsSelector,
} from '../../../modules/SignUp/PhoneNumber/reducer';
import {activateSim} from '../../../modules/SignUp/actions';

import ConfirmPlan from './ConfirmPlan.container';

import type {PaymentMeanType} from 'digicel-kaizen-library';
import type {StateType} from '../../../modules/reducers';
import type {Props} from './ConfirmPlan';

import type {
  NavigationRoute,
  NavigationScreenProp,
} from '@react-navigation/compat';
import {
  setCurrentVoucherDetails,
  setVoucherDetailsComeFrom,
  voucherCurrentVoucherDetailsSelector,
  voucherFilteredAvailableVouchersSelectorLazy,
} from '../../../modules/Voucher';
import {
  eSimSelectedSelector,
  eSimProductPriceSelector,
} from '../../../modules/ESim/selectors';
import {fetchFreeTrialActivationBonus} from '../../../modules/Bonuses';
import {freeTrialActivationBonusStateSelector} from '../../../modules/Bonuses';

type StateProps = {
  activationBonusAmount: ?number,
  agreementText: string,
  bringBackTo: string,
  confirmButtonLabel: string,
  editPlanRoute: string,
  hideCheckboxes: boolean,
  isConfirmPlanLoading: boolean,
  isKeepingNumber: boolean,
  isReferralPromotionDiscount: boolean,
  isVerifyingBonuses: ?boolean,
  modalHtmlFile: string,
  paymentMean: PaymentMeanType,
  phoneNumber: ?string,
  price: number,
  skipPayment: boolean,
  temporaryPhoneNumber: string,
};

type DispatchProps = {
  activateSim: Function,
  fetchAgreements: Function,
  mockConfirmPayment: Function,
  verifyBonuses: Function,
};

const mapStateToProps = (state: StateType): StateProps => ({
  activationBonusAmount: activationBonusAmountSelector(state),
  agreementText: I18n.t('SignUp.ConfirmPlan.termsConditions'),
  bringBackTo: 'confirmPlanDuringActivate',
  confirmButtonLabel: 'confirmAndPay',
  editPlanRoute: 'editPlanDuringActivate',
  hideCheckboxes: hasAlreadyValidatedNeededAgreementsSelector(state),
  isConfirmPlanLoading: isLoadingSelector(state, 'activateSim'),
  isKeepingNumber: !!portabilityCharacteristicsSelector(state),
  isReferralPromotionDiscount: isDiscountSelector(state),
  isVerifyingBonuses: isLoadingSelector(state, 'verifyBonuses'),
  modalHtmlFile: 'toc.html',
  paymentMean: customPaymentMeanSelector(state),
  phoneNumber: chosenPhoneNumberSelector(state),
  price: newOfferPriceSelector(state),
  skipPayment: hasCustomPaymentMeanSelector(state),
  temporaryPhoneNumberWhenEsimSelected:
    phoneNumbersSelector(state)[0] &&
    phoneNumbersSelector(state)[0].phoneNumber,
  temporaryPhoneNumber:
    getSelectedLinePhoneNumber(state) ||
    phoneNumbersSelector(state)[0].phoneNumber,
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
  filteredAvailableVouchers:
    voucherFilteredAvailableVouchersSelectorLazy(state),
  eSimSelected: eSimSelectedSelector(state),
  eSimPrice: eSimProductPriceSelector(state),
  freeTrialActivationBonus: freeTrialActivationBonusStateSelector(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  activateSim: () => dispatch(activateSim()),
  fetchAgreements: (isSignup, options) =>
    dispatch(fetchAgreementsByProductOfferings(isSignup, options)),
  mockConfirmPayment: paymentInfo =>
    dispatch(addPaymentMeanDuringActivate({paymentInfo})),
  verifyBonuses: () => dispatch(verifyBonuses()),
  setVoucherDetailsComeFrom: (comeFrom: string) =>
    setVoucherDetailsComeFrom(comeFrom),
  setCurrentVoucherDetails: (object: Object) =>
    setCurrentVoucherDetails(object),
  fetchFreeTrial: () => fetchFreeTrialActivationBonus(),
});

const withActivationProps = (): {confirmPlanType: string} => ({
  confirmPlanType: 'activation',
});

const navigateToPaymentRegistration = (
  navigation: NavigationScreenProp<NavigationRoute>,
  options: Object,
) =>
  navigation.navigate('registerPaymentDetailsDuringActivate', {
    redirectTo: 'paymentDuringActivate',
    ...options,
  });

const mergeProps = (stateProps, dispatchProps, ownProps): Props => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  goToNewPaymentMeanPage: () =>
    navigateToPaymentRegistration(ownProps.navigation, {
      bringBackTo: stateProps.bringBackTo,
      isPaymentMeanUpdate: true,
    }),
  submit: () => {
    dispatchProps.activateSim();
  },
});

export default compose(
  withProps(withActivationProps()),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(ConfirmPlan);
